module.exports = __webpack_public_path__ + "img/gb3.baafbd55.png";